import { ApiUrl, ApiUrlVC} from '../utils'

// const ApiUrl = {//URL's correspondientes a sus respectivos ambientes
//   ambient: () => {
//     // let selected = `https://techhub.docsolutions.com/OBAvisCap/WebApi/api/`;
//     let selected = `${process.env.REACT_APP_DSONBOARDING_API}`;
//     return selected;
//   }
// }

const Api = {//Complemento de url de api
  //authentication: 'authentication/authentication',
  authentication: 'authentication/authenticationwithrefer',
  SSOAuthenticate: "authentication/authenticationwhitmsal",
  getClientIPsWithRefer: "authentication/GetClientIPsWithRefer",
  Disabletoken: "authentication/disabletoken",
  checkAcceptanceCfg: 'workflow/GetResourceData',//API de check de aceptación
  getWorkflowDefinitions: 'workflow/GetWorkFlowDefinitions',
  continueWorkflowApi: 'workflow/ContinueWorkFlow',//continuar el flujo de solicitud
  cancelWorkFlow: 'workflow/CancelWorkFlow',
  getWorkFlowDefinition: 'workflow/GetWorkFlowDefinition',
  checkAcceptanceConfirm: 'file/CheckAcceptanceConfirm',
  getFileByGUID: 'file/GetFileByGUID',
  generateFolioChildWorkflow: 'file/GenerateFolioChildWorkflow',
  getFileInfo: 'file/GetFileInfo',
  updateMetadata: 'file/UpdateMetadata',//Subir metadatos de cuestionario dinámico  
  generateFolioRemote: 'file/GenerateFolioRemote',
  documentUploadEvidence: 'file/UploadEvidence',//Subir documentos e INE (anverso y reverso)
  GetTextEvidence: 'file/GetTextEvidence',//Subir documentos e INE (anverso y reverso)
  checkAceptacionPdf: 'file/CheckAcceptanceCfg',
  optionsToSelect: 'file/SetSelectionValue',
  filesSearch: 'file/GetFiles',
  executeSearchCp: 'ExecuteSearch/GetByCodigoPostal',//Obtener datos de catálogo CP
  uploadDocument: 'extraction/CargaDocumento',//Subir documentos e INE (anverso y reverso)
  uploadSection: 'document/UploadSection',//Subir documentos a flujo normal
  downloadDocument: 'document/DownloadDocument',//Obtener datos de catálogo CP
  getDocument: 'document/DownloadDocumentContent',
  autographSignDocument: 'document/AutographSignDocument',
  Backlist: 'BlackList/GetBlackList',
  getNewCreditOption: 'credit/GetNewCreditOption',
  asignateNewCreditOption: 'credit/AsignateNewCreditOption',
  validatePINActivateUser: 'validation/ValidatePINActivateUser',
  validateCAPTCHA: 'validation/ValidateCAPTCHA',
  validateDocument: 'validation/RegisterDocumentValidation',
  validatePIN: 'validation/ValidatePINStageFile',
  validatePINChangePassword: 'validation/ValidatePINChangePassword',
  productsRemote: 'product/GetProductsRemote',
  resendNip: 'notification/NotificationPINStageFile',//Reenvió de pin de autorización
  notificationPINChangePassword: 'notification/NotificationPINChangePassword',
  registerChangePassword: 'user/RegisterChangePassword',
  biometricResults: 'biometric/GetBiometricStatus',
  graphData: 'graph/GetGraphsData',
  continueStageActorSelection: 'file/ContinueStageActorSelection',
  ocrData: 'extraction/OcrExtractionResult',
  binnacle: 'workflow/GetStageRecords',
  qrUid: 'qrcode/GenerateQRUID',
  qrImage: 'notification/GenerateQRImage',
  qrUidData: 'qrcode/GetQRUIDData',
  associatedFile: 'qrcode/GetAssociateFileData',
  registerMetadata: 'document/RegisterExtraccionData',
  downloadSection: 'document/DownloadSection',
  facialComparison: 'document/FacialComparison',
  registerDataTwo: 'document/RegisterIdentityData2',
  generateFolio: 'file/GenerateFolio',
  getActorByGroup: 'file/GetActorByGroup',
  getActors: 'file/GetActors',
  validateIdentityData: 'document/ValidateIdentityData',
  getValidateIdentityData: 'document/GetValidateIdentityData',
  uploadDocumentSectionContent: 'document/UploadDocumentSectionContent',
  setGroupName: 'file/SetGroupName',
  registerActor: 'file/RegisterActor',
  startActorFlow: 'file/StartActorFlow',
  removeActor: 'file/RemoveActor',
  updateActorsRole: 'file/UpdateActorsRole',
  registerCertificateType01: 'certificate/RegisterCertificateType01',
  registerCertificateType02: 'certificate/RegisterCertificateType02',
  getDocumentAceptance: 'certificate/GetDocumentAceptance',
  uploadVideoEvidenceContent: 'file/UploadVideoEvidenceContent',
  uploadVideoEvidenceContentJsonResult: 'file/UploadVideoEvidenceContentJsonResult',
  registerStatusStage: 'workflow/RegisterStatusStage',
  uploadMinutiae: 'document/UploadMinutiae',
  getCobranzaPagos: 'credit/GetCobranzaPagos',
  generarDatosCobranzaUnico: 'credit/GenerarDatosCobranzaUnico',
  setManualConfigurations: 'file/SetManualConfigurations',
  getCobranzaCobro: 'credit/GetCobranzaCobro',
  digitalSignSATDocument: 'document/DigitalSignSATDocument',
  getUserGoal: 'credit/GetUserGoal',
  registerUserGoal: 'credit/RegisterUserGoal',
  getFileInfoByFolio: 'file/GetFileInfoByFolio',
  getDependencies: 'credit/GetDependencies',
  getCalculateDataFile: 'credit/GetCalculateDataFile',
  generateFolioExterno: 'file/GenerateFolioExterno',
  getFaceDetection: 'document/GetFaceDetection',
  getFaceFeeling: 'document/GetFaceFeeling',
  getFaceDetectionIDRND: 'document/GetFaceDetectionIDRND',
  cargaDocumentoWithSection: 'extraction/CargaDocumentoWithSection',
  verifyStatusCertificate: 'document/VerifyStatusCertificate',
  getBySelectedOption: 'ExecuteSearch/GetBySelectedOption',
  recoverChangePassword: 'user/ChangePassword',
  getByCustomCatalog: 'ExecuteSearch/GetByCustomCatalog',//Obtener datos de catálogo CP
  registerSurveyAnswers: 'file/RegisterSurveyAnswers',
  getSurveyQuestions: 'file/GetSurveyQuestions',

  getSignatureRequestsByUsuario: 'flujomasivo/GetSignatureRequestsByUsuario',//Obtener datos de catálogo CP
  uploadBatchSign: 'flujomasivo/UploadBatchSign',//Obtener datos de catálogo CP

  getDocumentGeneratorSelection: "document/GetDocumentGeneratorSelection",
  registerDocumentGeneratorSelection: "document/RegisterDocumentGeneratorSelection",
  downloadDocumentGeneratorSelectionContent: "document/DownloadDocumentGeneratorSelectionContent",
  processDocumentGeneratorSelection: "document/ProcessDocumentGeneratorSelection",

  getPresentationVC: 'verifier/presentation-request?SignalR=',
  authenticatorGeneraCredential: 'issuer/issue-request'

}

export const AppUrls = {//Concatenación y retorno de URL según ambiente seleccionado
  CheckAcceptanceCfg: `${ApiUrl.ambient}${Api.checkAcceptanceCfg}`,
  CheckAcceptanceConfirm: `${ApiUrl.ambient}${Api.checkAcceptanceConfirm}`,//Guardar datos de check de aceptación
  GetClientIPsWithRefer: `${ApiUrl.ambient}${Api.getClientIPsWithRefer}`,
  Authentication: `${ApiUrl.ambient}${Api.authentication}`,
  SSOAuthenticate: `${ApiUrl.ambient}${Api.SSOAuthenticate}`,
  Disabletoken: `${ApiUrl.ambient}${Api.Disabletoken}`,
  GetWorkFlowDefinitions: `${ApiUrl.ambient}${Api.getWorkflowDefinitions}`,
  UpdateMetadata: `${ApiUrl.ambient}${Api.updateMetadata}`,
  ExecuteSearchCp: `${ApiUrl.ambient}${Api.executeSearchCp}`,
  GetBySelectedOption: `${ApiUrl.ambient}${Api.getBySelectedOption}`,
  getFileByGUID: `${ApiUrl.ambient}${Api.getFileByGUID}`,
  GenerateFolioChildWorkflow: `${ApiUrl.ambient}${Api.generateFolioChildWorkflow}`,
  GetFileInfo: `${ApiUrl.ambient}${Api.getFileInfo}`,
  GenerateFolioRemote: `${ApiUrl.ambient}${Api.generateFolioRemote}`,
  UploadDocuments: `${ApiUrl.ambient}${Api.uploadDocument}`,
  DocumentUploadEvidence: `${ApiUrl.ambient}${Api.documentUploadEvidence}`,
  GetTextEvidence: `${ApiUrl.ambient}${Api.GetTextEvidence}`,
  UploadSectionApi: `${ApiUrl.ambient}${Api.uploadSection}`,
  ContinueWorkflowApi: `${ApiUrl.ambient}${Api.continueWorkflowApi}`,
  DownloadDocument: `${ApiUrl.ambient}${Api.downloadDocument}`,
  Backlist: `${ApiUrl.ambient}${Api.Backlist}`,
  GetNewCreditOption: `${ApiUrl.ambient}${Api.getNewCreditOption}`,
  AsignateNewCreditOption: `${ApiUrl.ambient}${Api.asignateNewCreditOption}`,
  ValidatePINActivateUser: `${ApiUrl.ambient}${Api.validatePINActivateUser}`,
  ProductsRemote: `${ApiUrl.ambient}${Api.productsRemote}`,
  ValidateCAPTCHA: `${ApiUrl.ambient}${Api.validateCAPTCHA}`,
  checkDeAceptacionPDF: `${ApiUrl.ambient}${Api.checkAceptacionPdf}`,
  GetDocument: `${ApiUrl.ambient}${Api.getDocument}`,
  CancelWorkFlow: `${ApiUrl.ambient}${Api.cancelWorkFlow}`,
  ResendNip: `${ApiUrl.ambient}${Api.resendNip}`,
  RegisterChangePassword: `${ApiUrl.ambient}${Api.registerChangePassword}`,
  ValidatePINChangePassword: `${ApiUrl.ambient}${Api.validatePINChangePassword}`,
  validatePIN: `${ApiUrl.ambient}${Api.validatePIN}`,
  NotificationPINChangePassword: `${ApiUrl.ambient}${Api.notificationPINChangePassword}`,
  AutographSignDocument: `${ApiUrl.ambient}${Api.autographSignDocument}`,
  GetBiometricResults: `${ApiUrl.ambient}${Api.biometricResults}`,
  SetOptionsToSelect: `${ApiUrl.ambient}${Api.optionsToSelect}`,
  GetWorkFlowDefinition: `${ApiUrl.ambient}${Api.getWorkFlowDefinition}`,
  GetFilesSearch: `${ApiUrl.ambient}${Api.filesSearch}`,
  SendDocumentValidation: `${ApiUrl.ambient}${Api.validateDocument}`,
  GetGraphsData: `${ApiUrl.ambient}${Api.graphData}`,
  GetOcrData: `${ApiUrl.ambient}${Api.ocrData}`,
  GetBinnacle: `${ApiUrl.ambient}${Api.binnacle}`,
  GetQrUid: `${ApiUrl.ambient}${Api.qrUid}`,
  GetQrImage: `${ApiUrl.ambient}${Api.qrImage}`,
  GetQrUidData: `${ApiUrl.ambient}${Api.qrUidData}`,
  GetAssociatedFile: `${ApiUrl.ambient}${Api.associatedFile}`,
  RegisterMetadata: `${ApiUrl.ambient}${Api.registerMetadata}`,
  DownloadSection: `${ApiUrl.ambient}${Api.downloadSection}`,
  GetFacialComparison: `${ApiUrl.ambient}${Api.facialComparison}`,
  RegisterDataTwo: `${ApiUrl.ambient}${Api.registerDataTwo}`,
  GenerateFolio: `${ApiUrl.ambient}${Api.generateFolio}`,
  GetActorByGroup: `${ApiUrl.ambient}${Api.getActorByGroup}`,
  GetActors: `${ApiUrl.ambient}${Api.getActors}`,
  ValidateIdentityData: `${ApiUrl.ambient}${Api.validateIdentityData}`,
  GetValidateIdentityData: `${ApiUrl.ambient}${Api.getValidateIdentityData}`,
  UploadDocumentSectionContent: `${ApiUrl.ambient}${Api.uploadDocumentSectionContent}`,
  SetGroupName: `${ApiUrl.ambient}${Api.setGroupName}`,
  RegisterActor: `${ApiUrl.ambient}${Api.registerActor}`,
  StartActorFlow: `${ApiUrl.ambient}${Api.startActorFlow}`,
  RemoveActor: `${ApiUrl.ambient}${Api.removeActor}`,
  UpdateActorsRole: `${ApiUrl.ambient}${Api.updateActorsRole}`,
  RegisterCertificateType01: `${ApiUrl.ambient}${Api.registerCertificateType01}`,
  RegisterCertificateType02: `${ApiUrl.ambient}${Api.registerCertificateType02}`,
  GetDocumentAceptance: `${ApiUrl.ambient}${Api.getDocumentAceptance}`,
  UploadVideoEvidenceContent: `${ApiUrl.ambient}${Api.uploadVideoEvidenceContent}`,
  UploadVideoEvidenceContentJsonResult: `${ApiUrl.ambient}${Api.uploadVideoEvidenceContentJsonResult}`,
  RegisterStatusStage: `${ApiUrl.ambient}${Api.registerStatusStage}`,
  UploadMinutiae: `${ApiUrl.ambient}${Api.uploadMinutiae}`,
  GetCobranzaPagos: `${ApiUrl.ambient}${Api.getCobranzaPagos}`,
  GenerarDatosCobranzaUnico: `${ApiUrl.ambient}${Api.generarDatosCobranzaUnico}`,
  SetManualConfigurations: `${ApiUrl.ambient}${Api.setManualConfigurations}`,
  GetCobranzaCobro: `${ApiUrl.ambient}${Api.getCobranzaCobro}`,
  DigitalSignSATDocument: `${ApiUrl.ambient}${Api.digitalSignSATDocument}`,
  ContinueStageActorSelection: `${ApiUrl.ambient}${Api.continueStageActorSelection}`,
  GetUserGoal: `${ApiUrl.ambient}${Api.getUserGoal}`,
  RegisterUserGoal: `${ApiUrl.ambient}${Api.RegisterUserGoal}`,
  GetFileInfoByFolio: `${ApiUrl.ambient}${Api.getFileInfoByFolio}`,
  GetDependencies: `${ApiUrl.ambient}${Api.getDependencies}`,
  GetCalculateDataFile: `${ApiUrl.ambient}${Api.getCalculateDataFile}`,
  GenerateFolioExterno: `${ApiUrl.ambient}${Api.generateFolioExterno}`,
  GetFaceDetection: `${ApiUrl.ambient}${Api.getFaceDetection}`,
  GetFaceFeeling: `${ApiUrl.ambient}${Api.getFaceFeeling}`,
  GetFaceDetectionIDRND: `${ApiUrl.ambient}${Api.getFaceDetectionIDRND}`,
  CargaDocumentoWithSection: `${ApiUrl.ambient}${Api.cargaDocumentoWithSection}`,
  VerifyStatusCertificate: `${ApiUrl.ambient}${Api.verifyStatusCertificate}`,
  RecoverChangePassword: `${ApiUrl.ambient}${Api.recoverChangePassword}`,
  GetByCustomCatalog: `${ApiUrl.ambient}${Api.getByCustomCatalog}`,
  RegisterSurveyAnswers: `${ApiUrl.ambient}${Api.registerSurveyAnswers}`,
  GetSurveyQuestions: `${ApiUrl.ambient}${Api.getSurveyQuestions}`,

  GetSignatureRequestsByUsuario: `${ApiUrl.ambient}${Api.getSignatureRequestsByUsuario}`,
  UploadBatchSign: `${ApiUrl.ambient}${Api.uploadBatchSign}`,

  GetDocumentGeneratorSelection: `${ApiUrl.ambient}${Api.getDocumentGeneratorSelection}`,
  RegisterDocumentGeneratorSelection: `${ApiUrl.ambient}${Api.registerDocumentGeneratorSelection}`,
  DownloadDocumentGeneratorSelectionContent: `${ApiUrl.ambient}${Api.downloadDocumentGeneratorSelectionContent}`,
  ProcessDocumentGeneratorSelection: `${ApiUrl.ambient}${Api.processDocumentGeneratorSelection}`,

  AuthenticatorGeneraCredential: `${ApiUrlVC.ambientVC}${Api.authenticatorGeneraCredential}`,
  GetApiPresentation: `${ApiUrlVC.ambientVC}${Api.getPresentationVC}`,

}
